export * from "./GenericTrendsChart";
